import { Component, ViewChild } from "@angular/core";
import { NavController, NavParams, Platform, Slides, PopoverController } from "ionic-angular";
import { FirebaseService } from "../../services/firebase.service";
import { IPlan } from "../../models/plan";
import { Users } from "../../models/users";
import { PaypalPage } from "../paypal/paypal";

@Component({
  selector: "page-subscriptions",
  templateUrl: "subscriptions.html"
})
export class SubscriptionsPage {
  @ViewChild(Slides) slides: Slides;

  userData: Users;


  // payPalConfig = {

  //   env: 'sandbox',
  //   client: {
  //     sandbox: 'AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV',
  //   },
  //   commit: true,
  //   payment: (data, actions) => {
  //     console.log("data is", data, actions);
  //     return actions.payment.create({
  //       payment: {
  //         transactions: [
  //           { amount: { total: '0.99', currency: 'EUR' } }
  //         ]
  //       }
  //     });
  //   }
  // }

  public plans: IPlan[];

  public DiscountMonth: boolean = false;
  public monthPrice: string = "";
  public montDiscountPrice: string = "";
  public yearForMonth;
  public yearForMonthDiscount;

  public DiscountThreeMonth: boolean = false;
  public ThreemonthPrice: string = "";
  public ThreemontDiscountPrice: string = "";
  public yearForThreeMonth;
  public yearForThreeMonthDiscount;

  public DiscountYear: boolean = false;
  public yearPrice: string = "";
  public YearDiscountPrice: string = "";
  public MonthForYear;
  public MonthForYearDiscount;

  public selectPlan = 2;

  isDesktop: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private Firesrv: FirebaseService,
    private platform: Platform,
    public popoverCtrl: PopoverController) {


    this.platform.ready().then(() => {

      if (this.platform.is("core")) {

        this.isDesktop = true;
        console.log(this.isDesktop);
      };

    });

    //verifica se ci sono le informazioni per il login automatico
    if (localStorage.getItem("UserDataLocal")) {
      this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));
    }

    //Recupera i dati dei piani di subscription
    this.Firesrv.GetPlanData().subscribe(res => {
      this.plans = res;
      console.log(res)

      // Verifica se c'è in atto uno sconto
      this.DiscountMonth = this.plans[1].Discount;
      this.DiscountYear = this.plans[2].Discount;
      this.DiscountThreeMonth = this.plans[3].Discount;

      // Carica i cossti impostati da DB
      this.montDiscountPrice = this.plans[1].DiscountPrice;
      this.monthPrice = this.plans[1].price;
      this.YearDiscountPrice = this.plans[2].DiscountPrice;
      this.yearPrice = this.plans[2].price;
      this.ThreemontDiscountPrice = this.plans[3].DiscountPrice;
      this.ThreemonthPrice = this.plans[3].price;

      // Calcola il costo sugli anni e mensilità
      // Abbonamento mensile
      this.yearForMonth = Number((+this.monthPrice).toFixed(2)) * 12;
      this.yearForMonthDiscount = Number((+this.montDiscountPrice).toFixed(2)) * 12;
      this.yearForMonth = (+this.yearForMonth).toFixed(2);
      this.yearForMonthDiscount = (+this.yearForMonthDiscount).toFixed(2);

      // Abbonamento trimestrale
      this.yearForThreeMonth = Number((+this.ThreemonthPrice).toFixed(2)) * 4;
      this.yearForThreeMonthDiscount = Number((+this.ThreemontDiscountPrice).toFixed(2)) * 4;
      this.yearForThreeMonth = (+this.yearForThreeMonth).toFixed(2);
      this.yearForThreeMonthDiscount = (+this.yearForThreeMonthDiscount).toFixed(2);

      // Abbonamento annuale
      this.MonthForYear = Number((+this.yearPrice).toFixed(2)) / 12;
      this.MonthForYearDiscount = Number((+this.YearDiscountPrice).toFixed(2)) / 12;
      this.MonthForYear = (+this.MonthForYear).toFixed(2);
      this.MonthForYearDiscount = (+this.MonthForYearDiscount).toFixed(2);

    });
    // });
  }



  /*
    payButtonHandler() {
      console.log('test paypal')
    //  paypal.Buttons(this.payPalConfig).render('#paypal-button');
  
      paypal.Buttons({
        env: 'sandbox',
        client: {
          sandbox: 'AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV',
        },
        // Set up the transaction
        createOrder: function (data, actions) {
          return actions.order.create({
            description: "Mobile World Store order-1234",
            purchase_units: [{
              description: "Mobile World Store order-1234",
              amount: {
                value: '2.01',
  
                description: "Mobile World Store order-1234",
              },
  
            }]
          });
        },
  
        // Finalize the transaction
        onApprove: function (data, actions) {
          return actions.order.capture()
            .then(function (details) {
              console.log(details);
              // Show a success message to the buyer
              alert('Transaction completed by ' + details.payer.name.given_name + '!');
            })
            .catch(err => {
              console.log(err);
            })
        }
      }).render('#paypal-button');
  
     }
  
     */

  Pay(SelctID) {

    switch (SelctID) {
      case 1: {

        let DescPay = "Abbonamento Mensile - BookFlix";
        let price = "0";

        if (this.DiscountMonth) {
          DescPay = DescPay + " - Scontato"
          price = this.montDiscountPrice
        } else {
          price = this.monthPrice
        }

        // this.paypalMonth(price, DescPay);
        this.ShowPayPal(SelctID, price, DescPay)
        break;
      }
      case 2: {

        let DescPay = "Abb. Trimestrale - BookFlix"
        let price = "0";

        if (this.DiscountThreeMonth) {
          DescPay = DescPay + " - Scontato"
          price = this.ThreemontDiscountPrice
        } else {
          price = this.ThreemonthPrice
        }

        //this.paypalThreeMonth(price, DescPay);
        this.ShowPayPal(SelctID, price, DescPay)
        break;
      }
      case 3: {

        let DescPay = "Abbonamento Annuale - BookFlix"
        let price = "0";

        if (this.DiscountYear) {
          DescPay = DescPay + " - Scontato"
          price = this.YearDiscountPrice
        } else {
          price = this.yearPrice
        }

        //this.paypalYear(price, DescPay);
        this.ShowPayPal(SelctID, price, DescPay)
        break;
      }
      default: {
        //statements;
        break;
      }
    }

  }

  ShowPayPal(PlanID, Price, Desc) {

    const popover = this.popoverCtrl.create(PaypalPage, { PlanID: PlanID, Price: Price, Desc: Desc }, { cssClass: "custom-popover", showBackdrop: false, enableBackdropDismiss: false });

    let ev = {
      target: {
        getBoundingClientRect: () => {
          return {
         
          };
        }
      }
    };

    popover.present({
      ev
      // ev: myEvent
    });

    popover.onDidDismiss(data => {

      if (data['Result'] > 0 || data['Result']) {
        const ResultPay = data['Result'];
        console.log('Piano acquistato con successo - ' + ResultPay)

        //Verifica se il pagamento è avveno con successo
        if (ResultPay > 0) {

          //Recupera il periodo
          let period = '';

          switch (ResultPay) {
            case 1: {
              period = "Mensile";
              break;
            }
            case 2: {
              period = "Trimestrale";
              break;
            }
            case 3: {
              period = "Annuale";
              break;
            }
            default: {
              //statements;
              break;
            }
          }

          // Calcola la data di scadenza dell'abbonamento
          let CurrentDate = new Date(Date.now());
          let EndDate = new Date(Date.now());
          EndDate.setMonth(EndDate.getMonth() + 3);

          // Setta la data
          this.userData.payment_date = CurrentDate.toUTCString();
          this.userData.renewal_date = EndDate.toUTCString();
          this.userData.cost = Price;
          this.userData.period = period;

          // Scrive i dati della subscription dcel Database
          this.Firesrv.SetUserData(this.userData);
          this.navCtrl.pop();

        }

      } else {
        console.log('annullato il pagamento)')
      };

    })

    // this.navCtrl.push(HistoryPaymentPage, );

  }

  goBack() {
    this.navCtrl.pop();
  }






  private ionViewDidEnter() {
    //   this.slider.update();
    if (!this.isDesktop) {
      this.slides.slideTo(1, 500);
    };
  }

  SelPlan(PlanID) {
    console.log(PlanID);
    this.selectPlan = PlanID;
  }

  ionViewDidLoad() {
    // console.log

    //("ionViewDidLoad SubscriptionsPage");

  }

  /*

  paypalMonth(price, type) {
    this.payPal
      .init({
        PayPalEnvironmentProduction: "",
        PayPalEnvironmentSandbox: "AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV"
      })
      .then(
        () => {
          this.payPal
            .prepareToRender(
              "PayPalEnvironmentSandbox", // da Cambiare in fase di produzione
              new PayPalConfiguration({
                acceptCreditCards: true,
                languageOrLocale: "it-IT",
                merchantName: "Fede & Cultura",
                merchantPrivacyPolicyURL: "",
                merchantUserAgreementURL: ""
                // Only needed if you get an "Internal Service Error" after PayPal login!
                //payPalShippingAddressOption: 2 // PayPalShippingAddressOptionPayPal
              })
            )
            .then(
              () => {
                let payment = new PayPalPayment(price, "EUR", type, "sale");

                this.payPal.renderSinglePaymentUI(payment).then(
                  response => {
                    console.log(response);
                    alert("Pagamento avvenuto con successo!");
                    // Successfully paid
                    // Example sandbox response
                    //
                    // {
                    //   "client": {
                    //     "environment": "sandbox",
                    //     "product_name": "PayPal iOS SDK",
                    //     "paypal_sdk_version": "2.16.0",
                    //     "platform": "iOS"
                    //   },
                    //   "response_type": "payment",
                    //   "response": {
                    //     "id": "PAY-1AB23456CD789012EF34GHIJ",
                    //     "state": "approved",
                    //     "create_time": "2016-10-03T13:33:33Z",
                    //     "intent": "sale"
                    //   }
                    // }

                    // Calcola la data di scadenza dell'abbonamento
                    let CurrentDate = new Date(Date.now());
                    let EndDate = new Date(Date.now());
                    EndDate.setMonth(EndDate.getMonth() + 1);

                    // Setta la data
                    this.userData.payment_date = CurrentDate.toUTCString();
                    this.userData.renewal_date = EndDate.toUTCString();
                    this.userData.cost = price;
                    this.userData.period = "Mensile";

                    // Scrive i dati della subscription dcel Database
                    this.Firesrv.SetUserData(this.userData);
                    this.navCtrl.pop();
                  },
                  err => {
                    // Error or render dialog closed without being successful
                    console.error(err);
                    // alert("ERRORE!");
                  }
                );
              },
              errConfig => {
                // Error in configuration
                console.error(errConfig);
                alert("Errore configurazione!");
              }
            );
        },
        ErrorSupp => {
          console.error(ErrorSupp);
          // Error in initialization, maybe PayPal isn't supported or something else
        }
      );
  }

  paypalThreeMonth(price, type) {
    this.payPal
      .init({
        PayPalEnvironmentProduction: "",
        PayPalEnvironmentSandbox: "AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV"
      })
      .then(
        () => {
          this.payPal
            .prepareToRender(
              "PayPalEnvironmentSandbox", // da Cambiare in fase di produzione
              new PayPalConfiguration({
                acceptCreditCards: true,
                languageOrLocale: "it-IT",
                merchantName: "Fede & Cultura",
                merchantPrivacyPolicyURL: "",
                merchantUserAgreementURL: ""
                // Only needed if you get an "Internal Service Error" after PayPal login!
                //payPalShippingAddressOption: 2 // PayPalShippingAddressOptionPayPal
              })
            )
            .then(
              () => {
                let payment = new PayPalPayment(price, "EUR", type, "sale");

                this.payPal.renderSinglePaymentUI(payment).then(
                  response => {
                    console.log(response);
                    alert("Pagamento avvenuto con successo!");
                    // Successfully paid
                    // Example sandbox response
                    //
                    // {
                    //   "client": {
                    //     "environment": "sandbox",
                    //     "product_name": "PayPal iOS SDK",
                    //     "paypal_sdk_version": "2.16.0",
                    //     "platform": "iOS"
                    //   },
                    //   "response_type": "payment",
                    //   "response": {
                    //     "id": "PAY-1AB23456CD789012EF34GHIJ",
                    //     "state": "approved",
                    //     "create_time": "2016-10-03T13:33:33Z",
                    //     "intent": "sale"
                    //   }
                    // }

                    // Calcola la data di scadenza dell'abbonamento
                    let CurrentDate = new Date(Date.now());
                    let EndDate = new Date(Date.now());
                    EndDate.setMonth(EndDate.getMonth() + 3);

                    // Setta la data
                    this.userData.payment_date = CurrentDate.toUTCString();
                    this.userData.renewal_date = EndDate.toUTCString();
                    this.userData.cost = price;
                    this.userData.period = "Trimestrale";

                    // Scrive i dati della subscription dcel Database
                    this.Firesrv.SetUserData(this.userData);
                    this.navCtrl.pop();
                  },
                  err => {
                    // Error or render dialog closed without being successful
                    console.error(err);
                    // alert("ERRORE!");
                  }
                );
              },
              errConfig => {
                // Error in configuration
                console.error(errConfig);
                alert("Errore configurazione!");
              }
            );
        },
        ErrorSupp => {
          console.error(ErrorSupp);
          // Error in initialization, maybe PayPal isn't supported or something else
        }
      );
  }

  paypalYear(price, type) {

    this.payPal
      .init({
        PayPalEnvironmentProduction: "",
        PayPalEnvironmentSandbox: "AQRpqaxD8fH4HO1KOb07uvXfGMc9O6NjAv8DFnz0UgIB33_K0nCJ1j-3OMsajZyEbSn5j8TCDYSBPsCV"
      })
      .then(
        () => {
          this.payPal
            .prepareToRender(
              "PayPalEnvironmentSandbox", // da Cambiare in fase di produzione
              new PayPalConfiguration({
                acceptCreditCards: true,
                languageOrLocale: "it-IT",
                merchantName: "Fede & Cultura",
                merchantPrivacyPolicyURL: "",
                merchantUserAgreementURL: ""
                // Only needed if you get an "Internal Service Error" after PayPal login!
                //payPalShippingAddressOption: 2 // PayPalShippingAddressOptionPayPal
              })
            )
            .then(
              () => {
                let payment = new PayPalPayment(price, "EUR", type, "sale");

                this.payPal.renderSinglePaymentUI(payment).then(
                  response => {
                    console.log(response);
                    alert("Pagamento avvenuto con successo!");

                    // Successfully paid
                    // Example sandbox response
                    //
                    // {
                    //   "client": {
                    //     "environment": "sandbox",
                    //     "product_name": "PayPal iOS SDK",
                    //     "paypal_sdk_version": "2.16.0",
                    //     "platform": "iOS"
                    //   },
                    //   "response_type": "payment",
                    //   "response": {
                    //     "id": "PAY-1AB23456CD789012EF34GHIJ",
                    //     "state": "approved",
                    //     "create_time": "2016-10-03T13:33:33Z",
                    //     "intent": "sale"
                    //   }
                    // }


                    try {
                      // Calcola la data di scadenza dell'abbonamento
                      let CurrentDate = new Date(Date.now());
                      let EndDate = new Date(Date.now());
                      EndDate.setFullYear(EndDate.getFullYear() + 1);

                      // Setta la data
                      this.userData.payment_date = CurrentDate.toUTCString();
                      this.userData.renewal_date = EndDate.toUTCString();
                      this.userData.cost = price;
                      this.userData.period = "Annuale";

                      // Scrive i dati della subscription dcel Database
                      this.Firesrv.SetUserData(this.userData);
                      this.navCtrl.pop();
                    } catch (error) {
                      console.error(error);
                      alert(error);
                    }

                  },
                  err => {
                    // Error or render dialog closed without being successful
                    console.error(err);
                    // alert("ERRORE!");
                  }
                );
              },
              errConfig => {
                // Error in configuration
                console.error(errConfig);
                alert("Errore configurazione!");
              }
            );
        },
        ErrorSupp => {
          console.error(ErrorSupp);
          // Error in initialization, maybe PayPal isn't supported or something else
        }
      );
  }
*/

}



// WEBPACK FOOTER //
// ./src/pages/subscriptions/subscriptions.ts